import { createBrowserRouter } from 'react-router-dom';
import { NotFound } from '@/pages';
import { LoginPage } from '@/features/auth/pages/LoginPage';
import { RegisterPage } from '@/features/auth/pages/RegisterPage';
import { TenantLayout } from '@/features/tenant/layouts/TenantLayout';
import { LandingPage } from '@/pages/LandingPage';
import { MobileLayout } from '@/layouts/MobileLayout';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { MailPage } from '@/features/mail/pages/MailPage';
import { BillsPage } from '@/features/wallet/pages/BillsPage';
import { MePage } from '@/features/me/pages/MePage';

export const router = createBrowserRouter([
    // Tenant Routes: /:inviteCode/login, /:inviteCode/register
    {
        path: '/:inviteCode',
        element: <TenantLayout />,
        children: [
            {
                path: 'login',
                element: <LoginPage />,
            },
            {
                path: 'register',
                element: <RegisterPage />,
            },
            {
                element: <MobileLayout />,
                children: [
                    { path: 'dashboard', element: <DashboardPage /> },
                    { path: 'mail', element: <MailPage /> },
                    { path: 'bills', element: <BillsPage /> },
                    { path: 'me', element: <MePage /> },
                ]
            }
        ],
    },
    // Landing Routes (No Layout)
    {
        path: '/',
        element: <LandingPage />,
    },
    {
        path: '/login',
        element: <LandingPage />,
    },
    {
        path: '/register',
        element: <LandingPage />,
    },
    // Fallback
    {
        path: '*',
        element: <NotFound />,
    },
]);
